import React, { FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import ButtonConciergeHomepage from '../../../images/button-concierge3.png';
import ButtonConciergeMobile from '../../../images/concierge-btn-mobile.png';

type LuxuryConcierge = {
  category: string;
  history: History;
};

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

const LuxuryConcierge: FC<LuxuryConcierge> = () => {

  // Display Luxury Concierge on mobile screen
  if(window.screen.availWidth < 480){
    return (
      <div
      className="button-concierge__Mobile"
      style={{ backgroundImage: `url(${ButtonConciergeMobile})` }}
    >
      <div className="button-text__Mobile">
        <h3>Concierge Service</h3>
        <p>
          Let us know about your wishlist so that we can find the best deal
          around just for you.
        </p>
        <a
          target="_blank"
          href="/luxury/concierge"
          className="button-cta__Mobile"
        >
          <h4>Request Concierge</h4>
        </a>
      </div>
    </div>
    )
  }

  // Display luxury concierge on desktop screen
  return (
    <div
      className="button-concierge__Desktop"
      style={{ backgroundImage: `url(${ButtonConciergeHomepage})` }}
    >
      <div className="button-text__Desktop">
        <h3>Concierge Service</h3>
        <p>
          Let us know about your wishlist so that we can find the best deal
          around just for you.
        </p>
      </div>
      <a
        target="_blank"
        href="/luxury/concierge"
        className="button-cta__Desktop"
      >
        <h4>Request Concierge Service</h4>
      </a>
    </div>
  );
};

export default LuxuryConcierge;
